import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Epop } from '@/models';

@Component({
  name: 'CmgEpopModal',
})
export default class CmgEpopModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.epop.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.epop.args;
  }

  get epops(): Epop[] {
    return (this.args && this.args.epops) || [];
  }

  onCancel() {
    this.$services.ui.setModalVisibility('epop', false);
  }
}
